import { TextField } from "@material-ui/core";
import { compose } from "ramda";
import { memo } from "react";
import { UseFormMethods } from "react-hook-form";

import { withError } from "../HOC";
import { CommonFormElProps } from "../types";

export type TimePickerProps = {
  readonly register: UseFormMethods["register"];
} & CommonFormElProps;

export const TimePicker = memo<TimePickerProps>(
  ({
    disabled: isDisabled = false,
    defaultValue,
    hasError,
    id,
    label,
    register,
    required = false,
  }) => (
    <TextField
      autoComplete="off"
      disabled={isDisabled}
      error={hasError}
      defaultValue={defaultValue}
      id={id}
      type="time"
      inputRef={register}
      InputProps={{
        name: id,
        notched: false,
      }}
      InputLabelProps={{
        disabled: isDisabled,
        required: !isDisabled && required,
        shrink: true,
      }}
      label={label}
      variant="outlined"
    />
  )
);

export const TimePickerWithError = compose(withError)(TimePicker);
